module.exports = __webpack_public_path__ + "static/footer01-2-dc6e40838c15f93c824642064adc76cf.png";